<template>
  <SignUp msg="Welcome to Your Vue.js App" />
  <Modal name="Nick"></Modal>
</template>

<script>
import SignUp from "./components/SignUp.vue";
import Modal from "./components/Modal.vue";

export default {
  name: "App",
  components: {
    SignUp,
    Modal,
  },
};
</script>

<style>
#app {
  padding: 15px;
}
</style>
